/**************************************************************************
 * Created on Tue Aug 27 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import React, { CSSProperties, useEffect, useState } from 'react';
import './index.scss';
import DSSButton from '../../../../ui/building-blocks/atoms/dss-button';
import DSSTooltip from '../../../../ui/building-blocks/atoms/dss-tooltip';
import { ReactComponent as ChevronDown } from '../../../../assets/svgs/chevron-down.svg'
import { ReactComponent as ChevronUp } from '../../../../assets/svgs/chevron-up.svg';
import { useDssContext } from '../../../../DSSContext';
interface ISideBarCommon {

    title: string;
    subMenus?: ISidebarMenuItem[];
    onClick?: () => void;
    className?: string,
    style?: CSSProperties,
    active: string;
    count?: number;
    badgeClass?: string;
    leftmenu?: boolean;

}

interface ISideBarMenuItemWithoutIcon extends ISideBarCommon {

    hasIcon?: false;
    hasLeftBox?: boolean,
    iconAssetPath?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;

}

interface ISideBarMenuItemWithIcon extends ISideBarCommon {

    hasIcon: true;
    hasLeftBox?: false,
    iconAssetPath: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;

}
export type ISidebarMenuItem = ISideBarMenuItemWithIcon | ISideBarMenuItemWithoutIcon;

export const onActiveLink = (state: boolean) => {
    if (state) {
        return 'active';
    }
    return ''
}
export const SideBarMenuItem = (props: ISidebarMenuItem & {
    openSubMenu?: string | null;
    setOpenSubMenu?: (key: string | null) => void;
    menuKey?: string;
}) => {
  const [submenuChildOpen, setSubmenuChildOpen] = useState<boolean>(false);
  const { active, setActive } = useDssContext();

    // const [showSubMenu, setShowSubMenu] = useState<boolean>(false);
    const [IconComp, setIconComp] = useState<React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }> | null>(null);
  const isControlled = !!(props.menuKey && props.setOpenSubMenu);
    const hasSubMenus = !!(props.subMenus && props.subMenus.length > 0);
  const isOpen = isControlled ? props.openSubMenu === props.menuKey : submenuChildOpen;
    const isRouteActive = props.active === 'active' || props.className === 'active';
    const showActiveBackground = !hasSubMenus && isRouteActive;
    const showActiveText = (hasSubMenus && isOpen) || isRouteActive;


  const handleClick = () => {
    if (active === '') {
      setActive(' active');
    }
    
    if (props.subMenus && props.subMenus.length > 0) {
      if (isControlled) {
        props.setOpenSubMenu && props.setOpenSubMenu(isOpen ? null : props.menuKey!);
      } else {
        setSubmenuChildOpen(o => !o);
      }
      props.onClick && props.onClick();
    } else {
      if (isControlled) props.setOpenSubMenu && props.setOpenSubMenu(null);
      props.onClick && props.onClick();
    }
  };


    useEffect(() => {
        if (props.iconAssetPath) {
            setIconComp(props.iconAssetPath);
        }
    }, [props.iconAssetPath]);


    // useEffect(() => {
    //     setShowSubMenu(props.className === 'active')
    // }, [props.className])
    return (
       <div style={{ ...(props.style || {}), width: "100%" }} className='menuItemcontainer'>
      <div className={`menuitem ${showActiveBackground ? 'active' : ''}`}>
        {(props.hasLeftBox && !props.hasIcon) && <div className='option' onClick={handleClick} />}
        {props.hasIcon && IconComp && (
          <div className='optionicon' onClick={handleClick}>
            <DSSTooltip text={props.title}>
              <IconComp />
            </DSSTooltip>
          </div>
        )}
        {props.leftmenu &&
          <div className="menu-item-wrapper">
            <DSSButton
              id={`btnmenu_${props.title}`}
              variant='link'
              className={`text ${showActiveText ? 'active-item' : 'inactive-item'}`}
              onClick={handleClick}
            >
              {props.title}
              {hasSubMenus && (
                isOpen ? <ChevronUp className='menu-chevron' /> : <ChevronDown className='menu-chevron' />
              )}
            </DSSButton>
            {props.count !== undefined && (
              <span className={props.badgeClass || "part2-badge badge-right"} style={{ marginLeft: 8 }}>
                {props.count}
              </span>
            )}
          </div>}
      </div>

            {isOpen && props.subMenus && props.subMenus.length > 0 && (
                <div className='submenucontainer'>
                    {props.subMenus.map((f: ISidebarMenuItem, i: number) => (
                        <SideBarMenuItem
                            {...f}
                            key={i + ""}
                            active={f.active || f.className || ""}

                        />
                    ))}
                </div>
            )}
        </div>
    );
};
